import { useCallback, useMemo } from 'react';
import type { SingleValue } from 'react-select';
import Select from 'react-select';
import { useTheme } from '@trinity/chat-components/components/Theme';
import type { FilterData } from './interfaces';
import { buildSelectStyles, buildSelectTheme } from './Presentation';

type AgentFilterItem = {
  id: number;
  identifier: string;
  label: string;
  type: number;
  operators: string[];
  data: FilterData;
};

type Props = {
  onSelect: (value: number) => void;
  value: number | null;
  options: AgentFilterItem[];
};

type Item = {
  id: number;
  name: string;
};

export function AgentFilterLabelSelect({ onSelect, value, options }: Props) {
  const theme = useTheme();

  const selectStyles = useMemo(() => buildSelectStyles(theme), [theme]);
  const selectTheme = useMemo(() => buildSelectTheme(theme), [theme]);

  const items: Item[] = useMemo(() => {
    return options.map(filter => ({
      id: filter.id,
      name: filter.label,
    }));
  }, [options]);

  const selectedValue = useMemo(() => items.find(f => f.id === value), [items, value]);

  const handleChange = useCallback((value: SingleValue<Item>) => {
    if (value) {
      onSelect(value.id);
    }
  }, [onSelect]);

  return (
    <Select<Item>
      styles={selectStyles}
      isSearchable={false}
      theme={selectTheme}
      value={selectedValue}
      options={items}
      placeholder="Select a filter..."
      getOptionLabel={o => o.name}
      getOptionValue={o => `${o.id}`}
      onChange={handleChange}
      menuPlacement="auto" />
  );
}
